import React from 'react';
import { MessageCircle } from 'lucide-react';
import { homestayInfo } from '../data/mockData';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello! I'd like to inquire about booking at White Orchid Homestay.");
    window.open(`https://wa.me/${homestayInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#20BA5A] text-white px-5 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl group"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-6 h-6 group-hover:rotate-12 transition-transform" />
      <span className="font-medium hidden sm:inline">WhatsApp</span>
    </button>
  );
};

export default WhatsAppButton;
